$(function(){
  var xsisoftimage = null;
  var is_ajax = parseInt($('#cottages').data('ajax')) == 1 ? true : false;
  var tplNumber = $('#iNumber').html();
  var tplLoading = $('#iLoad').html();
  var tplNone = $('#iNone').html();
  var tplProduct = $('#iProduct').html();
  var params = is_ajax ? buildParams() : {};
  var template = '';
  var list = setAC_getUri();

  if (is_ajax) {
    fetchData();
  }

  //bind les input et select du search (pour pas reloader constamment la page u know wut im saying)
  $('form[name="search-form"]').find('input,select').on('change', function(e){
    params = buildParams();
    
    fetchData();
  });

  $('#cottages').on('click', '.cottage-thumbnail', function() {
    var loop_index = $(this).data('position');
    var item = {
      "id": $(this).data('id'),
      "name": $(this).data('name'),
      "list_name": $(this).data('list'),
      "list_position": loop_index
    }
    setAC_cottage(loop_index, item);
  });

  initThumbnails();

  //bind le form submit
  $('form[name="search-form"]').on('submit', function(e){
    e.preventDefault();

    params = buildParams();
    fetchData();
  });

  $('.rangePicker').on('datepicker-change', function(){
    params = buildParams();
    fetchData();
    $('.no-date-txt').remove();
  });

  //fetch cottages
  function fetchData() {
    displayLoading();

    xsisoftimage = $.ajax({
      url: $('#cottages').data('fetch'),
      dataType: 'json',
      data: params,
      beforeSend : function() {
        if(xsisoftimage != null) {
          xsisoftimage.abort();
        }
      },
    })
    .done(function(data) {
      var specificDays = 0;

      if (params.f != '' && params.t != '') {
        var momentf = moment(params.f),
        momentt = moment(params.t),
        specificDays = momentt.diff(momentf, 'days');
      }

      handleData(data, specificDays);
    })
    .fail(function(e) {
      if (e.statusText != 'abort') {
        console.error("euhh");
      }
    });
  }

  function myCustomGtag($params) {
    if (hasCookie('acceptedCookie')) {
      gtag($param);
    }
  }

  //handle cottages
  function handleData(data, specificDays) {
    //enlève la pagination selle existe
    $('#cottagesfooter').empty();

    //affiche toutes les chalets trouvés
    if (data.length > 0) {
      $('#cottages').empty();
      $('#cottageshead').empty();

      template = _.template(tplNumber);
      $('#cottageshead').append(template({
        total: data.length
      }));

      var items = [];


      template = _.template(tplProduct);
      var image = '';
      var average = 0;
      var cookies = readCookie('fav') != null ? readCookie('fav').split(',') : [];

      for (var i = 0; i < data.length; i++) {
        image = '';
        average = 0;

        items.push({
          "id": data[i].id,
          "name": data[i].name,
          "list_name": list,
          "list_position": i
        });

        if (data[i].average > 0) {
          average = parseFloat(data[i].average).toFixed(1);
        }

        if (data[i].image != '' || data[i].image != null) {
          image = data[i].image;
        }

        $('#cottages').append(template({
          'cottage_id': data[i].id,
          'cottage_detail': data[i].detail,
          'cottage_name': data[i].name,
          'cottage_name_alt': data[i].name.replace(/\"/g, "'"),
          'cottage_short': data[i].short,
          'peoples': parseInt(data[i].peoples),
          'bedrooms': parseInt(data[i].bedrooms),
          'sofa_bed': parseInt(data[i].sofa_bed),
          'futon': parseInt(data[i].futon),
          'conveniences': data[i].topConveniences,
          'gallery': data[i].gallery,
          'average': average,
          'image': image,
          'owner_image': data[i].owner_image,
          'specific': data[i].specific,
          'specific_days': specificDays,
          'online': data[i].online,
          'tarification': data[i].tarification,
          'reservation': data[i].reservation,
          'total': price(data[i].total),
          'total_no_rebate': price(data[i].total_no_rebate),
          'has_rebates': data[i].has_rebates,
          'rebate1': data[i].rebate1_percent > 0 ? parseInt(data[i].rebate1_percent) : null,
          'rebate2': data[i].rebate2_percent > 0 ? parseInt(data[i].rebate2_percent) : null,
          'rebate3': data[i].rebate3_percent > 0 ? parseInt(data[i].rebate3_percent) : null,
          'rebate1_name': data[i].rebate1_name,
          'rebate2_name': data[i].rebate2_name,
          'rebate3_name': data[i].rebate3_name,
          'in_cookie': cookies.indexOf(data[i].id.toString()) >= 0,
          'loop_index': i,
          'list': list,
        }));
      }

      gtag('event', 'view_item_list', {
        "items": items
      });

      bgcoverandstuff();
    }
    //affiche le template aucun résultat RIP
    else{
      template = _.template(tplNone);

      $('#cottageshead').empty();
      $('#cottages').empty().append(template());
    }
  }

  //build search form params (before the ajax)
  function buildParams() {
    var params = {};

    params.f = $('#search-from').val();
    params.t = $('#search-to').val();

    params.p = $('#search-peoples').val();
    params.b = $('#search-bedrooms').val();
    params.c = $.map($('input[name="c[]"]:checked'), function(element) {
      return $(element).val();
    }).join(',');
    params.a = $('input[name="a"]:checked').val();
    params.date = $('input[name="date"]').val();

    if (window.location.search.indexOf('page') >= 0) {
      history.pushState(params, "", window.location.origin + window.location.pathname);
    }

    return params;
  }

  //display loading screen
  function displayLoading(deleteOrNot) {
    deleteOrNot = deleteOrNot == undefined ? false : deleteOrNot;

    if (deleteOrNot) {
      $('#cottages').find('h4.loading').remove();
    }
    else {
      template = _.template(tplLoading);

      $('#cottages').empty().append(template());
      if($("#search-from").val() != ''){
        $("#search-peoples").css("display","block");
      }
    }
  }

  function bgcoverandstuff() {
    //tipsy </3
    $('#cottages .cottage-box').find('.tooltip').tipsy({
      gravity: 'n',
      fade: true
    });
    
    initThumbnails();
  }
});
